<template>
  <div class="field is-centered submit-button">
    <div class="control">
      <button
        class="button is-uppercase is-primary"
        type="submit"
        :class="{ 'is-loading': loading }"
        :disabled="disabled"
      >
        {{ text }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonSubmit',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
  },
};
</script>
